import React from 'react';

import SupportLeftNavButton from './SupportLeftNavButton';
import { parseQueryParams } from 'util/query-params-util';
import { useLocation } from 'react-router';
import { DEFAULT_TAG_TYPE } from './support-types';

export type SupportLeftNavMenuItem = {
  label: string;
  link: string;
  paramPath: string;
  component: React.ElementType<any>;
  exactRoute?: boolean;
};

function SupportLeftNavMenu({ supportResources }) {
  const location = useLocation();
  const params: any = parseQueryParams(location.search) ?? { active: DEFAULT_TAG_TYPE.HOW_TO };
  return (
    supportResources?.map((x, index: number) => (
      <SupportLeftNavButton key={index} active={params.active === x} label={x} />
    )) || null
  );
}

export default SupportLeftNavMenu;
